import React, { Component } from 'react';
import { Formik } from 'formik';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IAction, IAppState } from '../../models/action/core';
import * as Actions from '../../store/actions/profile';
import Input from '../../components/input/text/input-formik';
import { Log } from 'ng2-logger';
import { getValidation, RegExpSpecialCharacter, RegExpUpperCase } from '../../models/validations/profile-password-validation';
import { IChangePassword } from '../../models/pages/profile';
import Loading from '../../components/loading/loading';
import Translator from '../../core/i18n';
import { Notification } from '../../components/notification/main';
import { Button } from '../../components/ui-elements/main';

const T = Translator.create();
const _logger = Log.create('change-password');

export class CChangePassword extends Component<IChangePassword, any> {

    public closeButtonRef: HTMLButtonElement | null = null;
    public state = {
        oldPasswordVisibility: false,
        newPasswordVisibility: false,
        retryNewPasswordVisibility: false
    }
    constructor(props: any) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
    }

    public onSubmit(values: any) {
        this.props.dispatch(Actions.changePasswordAction(values, 'changePasswordLoading', 'get'));
    }

    handleValidationErrors = (validateFunc: () => Promise<any>,submitFunc: () => void) => {
        validateFunc().then((errors: any) => {
            if (Object.keys(errors).length > 0) {
                if(errors.oldPassword == T.t('r_enter_old_password')) {
                    Notification.setNotification('error', T.t('r_old_password_field_required'), 'topRight')
                }
                if(errors.newPassword == T.t('r_field_required')) {
                    Notification.setNotification('error', T.t('r_new_password_field_required'), 'topRight')
                }
                if(errors.confirmNewPassword == T.t('r_field_required')) {
                    Notification.setNotification('error',T.t('r_new_password_repeat_field_required'), 'topRight')
                }

            }else {
                submitFunc()
            }
        });
    };

    public componentDidUpdate(prevProps: any, prevState: any) {
        if (this.props.isChangePassword === true) {
            if (this.state.newPasswordVisibility === prevState.newPasswordVisibility && this.state.oldPasswordVisibility === prevState.oldPasswordVisibility && this.state.retryNewPasswordVisibility === prevState.retryNewPasswordVisibility) {
                if (this.closeButtonRef) {
                    this.closeButtonRef.click();
                }
            }

        }
    }

    getValidation = () => {
        return getValidation({
            minPassWordLength: this.props?.requisiteMinPasswordLength ?? 0,
            minNonAlphanumericLength: this.props?.minNonAlphanumericLength ?? 0
        })
    }

    public render() {
        const initialFormValues = {
            newPassword: '',
            userId: this.props.userId,
            confirmNewPassword:'',
            oldPassword: ''
        };
        const IconTypes = {
            oldPassIconType: this.state.oldPasswordVisibility ? 'visibility_off' : 'visibility',
            newPassIconType: this.state.newPasswordVisibility ? 'visibility_off' : 'visibility',
            retryNewPassIconType: this.state.retryNewPasswordVisibility ? 'visibility_off' : 'visibility'
        }

        return (
            <Formik
                initialValues={initialFormValues}
                onSubmit={this.onSubmit}
                validationSchema={this.getValidation}
                /* tslint:disable-next-line */
                render={propsFormik => (
                    <form onSubmit={propsFormik.handleSubmit}>
                        <div className="modal change-password" id="change-password" tabIndex={-1} role="dialog">
                            <div className="modal-dialog modal-dialog-centered" role="document">
                                <Loading top={'40%'} spinnerId={'changePasswordLoading'} />
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">{T.t('r_change_password')}</h5>
                                        {!this.props.forceChange ? (
                                            <button
                                                ref={e => (this.closeButtonRef = e)}
                                                type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                aria-label="Close"
                                                style={{ marginInlineEnd: '0px' }}
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                        ) : null}
                                    </div>
                                    <p>{T.t('r_define_password_fields')}</p>
                                    {this.props.requisiteMinPasswordLength && this.props.requisiteMinPasswordLength > 0 ? (
                                        <div className="tick-radio position-relative mb-3">
                                            <input
                                                type="checkbox"
                                                name="characterRadio"
                                                checked={propsFormik.values.newPassword.length >= this.props.requisiteMinPasswordLength}
                                                id="time-22"
                                                className="form-radio rounded-circle"
                                            />
                                            <label htmlFor="time-22">
                                                {T.t('r_eight_plus_character_define').replace('{0}', this.props.requisiteMinPasswordLength)}
                                            </label>
                                        </div>
                                    ) : null}

                                    <div className="tick-radio position-relative mb-3">
                                        <input
                                            type="checkbox"
                                            name="bigLetterRadio"
                                            id="time-22"
                                            checked={RegExpUpperCase.test(propsFormik.values.newPassword)}
                                            className="form-radio rounded-circle"
                                        />
                                        <label htmlFor="time-22">{T.t('r_uppercase_letter_define')}</label>
                                    </div>

                                    <div className="tick-radio position-relative mb-3">
                                        <input
                                            type="checkbox"
                                            name="specialCharacterRadio"
                                            id="time-22"
                                            checked={RegExpSpecialCharacter.test(propsFormik.values.newPassword)}
                                            className="form-radio rounded-circle"
                                        />
                                        <label htmlFor="time-22">{T.t('r_special_character_define')}</label>
                                    </div>

                                    <div>
                                        <Input
                                            type={this.state.oldPasswordVisibility ? 'text' : 'password'}
                                            name={'oldPassword'}
                                            placeHolder={T.t('r_old_password')}
                                            label={T.t('r_old_password')}
                                            formik={propsFormik}
                                            render={
                                                <i
                                                    onClick={() =>
                                                        this.setState({ oldPasswordVisibility: !this.state.oldPasswordVisibility })
                                                    }
                                                    className="material-icons password-change-icon"
                                                    style={{
                                                        position: 'absolute',
                                                        cursor: 'pointer',
                                                        color: 'black',
                                                        marginTop: '10px'
                                                    }}
                                                >
                                                    {IconTypes.oldPassIconType}
                                                </i>
                                            }
                                        />
                                    </div>

                                    <div>
                                        <Input
                                            type={this.state.newPasswordVisibility ? 'text' : 'password'}
                                            name={'newPassword'}
                                            placeHolder={T.t('r_new_password')}
                                            formik={propsFormik}
                                            noSpace={true}
                                            label={T.t('r_new_password')}
                                            render={
                                                <i
                                                    onClick={() =>
                                                        this.setState({ newPasswordVisibility: !this.state.newPasswordVisibility })
                                                    }
                                                    className="material-icons password-change-icon"
                                                    style={{
                                                        position: 'absolute',
                                                        cursor: 'pointer',
                                                        color: 'black',
                                                        marginTop: '10px'
                                                    }}
                                                >
                                                    {IconTypes.newPassIconType}
                                                </i>
                                            }
                                        />
                                    </div>

                                    <div>
                                        <Input
                                            type={this.state.retryNewPasswordVisibility ? 'text' : 'password'}
                                            name={'confirmNewPassword'}
                                            placeHolder={T.t('r_re_new_password')}
                                            formik={propsFormik}
                                            noSpace={true}
                                            label={T.t('r_re_new_password')}
                                            render={
                                                <i
                                                    onClick={() =>
                                                        this.setState({
                                                            retryNewPasswordVisibility: !this.state.retryNewPasswordVisibility
                                                        })
                                                    }
                                                    className="material-icons password-change-icon"
                                                    style={{
                                                        position: 'absolute',
                                                        cursor: 'pointer',
                                                        color: 'black',
                                                        marginTop: '10px'
                                                    }}
                                                >
                                                    {IconTypes.retryNewPassIconType}
                                                </i>
                                            }
                                        />
                                    </div>

                                    <div
                                        className={
                                            !this.props.forceChange
                                                ? 'modal-footer border-0 mini-btn'
                                                : 'modal-footer border-0 mini-btn justify-content-end'
                                        }
                                    >
                                        {!this.props.forceChange ? (
                                            <button type="button" data-dismiss="modal" className="btn btn-gray min-auto">
                                                {T.t('r_cancel_button')}
                                            </button>
                                        ) : null}
                                        {/* <button
                                            onClick={() => {
                                                this.handleValidationErrors(propsFormik.validateForm,propsFormik.submitForm)
                                            }}
                                            name={'changePasswordSave'}
                                            type="button"
                                            className="btn btn-green min-auto"
                                        >
                                            {T.t('r_save_button')}
                                        </button> */}
                                        <Button button_type='primary' size='medium' text={T.t('r_save_button')} onClick={() => {
                                                this.handleValidationErrors(propsFormik.validateForm,propsFormik.submitForm)
                                            }}></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            />
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IChangePassword): IChangePassword => {
    if (!state) {
        return ownProps;
    }

    const newProps: IChangePassword = Object.assign({}, ownProps, {
        userId: state.login.identitiy.userId,
        isChangePassword: state.profile.isChangePassword,
        requisiteMinPasswordLength: state.login.login.requisiteMinPasswordLength,
        minNonAlphanumericLength: state.login.login.minNonAlphanumericLength
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.login.identitiy === prev.login.identitiy &&
        next.profile.isChangePassword === prev.profile.isChangePassword &&
        next.login.login.requisiteMinPasswordLength === prev.login.login.requisiteMinPasswordLength &&
        next.login.login.minNonAlphanumericLength === prev.login.login.minNonAlphanumericLength
    );
    return ret;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const ChangePassword = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(CChangePassword);

export default ChangePassword;
